var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 35,
    viewBox: "0 0 37 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11217",
    "data-name": "Group 11217",
    transform: "translate(-1244.5 -12.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8925",
    "data-name": "Rectangle 8925",
    width: 37,
    height: 35,
    rx: 17.5,
    transform: "translate(1244.5 12.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11214",
    "data-name": "Group 11214",
    transform: "translate(-1.494)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15485",
    "data-name": "Path 15485",
    d: "M1264.51,22.8a4.754,4.754,0,0,0-4.75,4.75v2.288a3.719,3.719,0,0,1-.45,1.631l-.91,1.512a1.522,1.522,0,0,0,.86,2.32,16.546,16.546,0,0,0,10.5,0,1.587,1.587,0,0,0,.86-2.32l-.91-1.512a3.859,3.859,0,0,1-.45-1.631V27.554A4.759,4.759,0,0,0,1264.51,22.8Z",
    fill: "none",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15486",
    "data-name": "Path 15486",
    d: "M1265.98,23.033a4.919,4.919,0,0,0-.76-.158,5.35,5.35,0,0,0-2.17.158,1.574,1.574,0,0,1,2.93,0Z",
    fill: "none",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15487",
    "data-name": "Path 15487",
    d: "M1266.89,35.589a2.375,2.375,0,0,1-4.75,0",
    fill: "none",
    stroke: "#191919",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.1d835d98f33933bc79fb5f031b61b46e.svg";
export { ForwardRef as ReactComponent };